export default "__VITE_ASSET__CPQBtPOw__"